import { connect } from 'react-redux';
import ConsentRequestDetails from './ConsentRequestDetails';
import { getTranslation } from "../../../reducers/common/localization";
import { getCurrentConsentRequestData, loadingCurrentConsentRequest, getCurrentConsentRequestId } from "../../../reducers/consent/organizationConsents";
import { resetSubmitFormData } from '../../../reducers/common/submitForm';
import { getOrgData } from '../../../reducers/organization/organization';
import { getUserId } from '../../../reducers/account/userData';
import {
    MODAL_CANCEL_CONSENT_REQUEST, MODAL_DISMISS_CONSENT_REQUEST,
    showModal
} from "../../../reducers/common/activeModal";

const mapStateToProps = (state) => {
    return {
        id: getCurrentConsentRequestId(state),
        data: getCurrentConsentRequestData(state),
        organizationData: getOrgData(state),
        userId: getUserId(state),
        loading: loadingCurrentConsentRequest(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCancelPendingRequest: () => dispatch(showModal({ modalKey: MODAL_CANCEL_CONSENT_REQUEST })),
        onDismissRequest: () => dispatch(showModal({ modalKey: MODAL_DISMISS_CONSENT_REQUEST })),
        onResetSubmitFormData: () => dispatch(resetSubmitFormData())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConsentRequestDetails);



// WEBPACK FOOTER //
// ./src/components/organizationConsentManagement/consentRequestDetails/ConsentRequestDetails.container.js